import {
    AutoSyncOff,
    CheckCircleIcon,
    colors,
    RadioButtonCheckedIcon
} from "@dotnet/telematics-design-system";

import { CONFIGURATION_FEATURE_SETTINGS_MODES } from "shared/types/enums";

export const SYNC_MODE_OPTIONS = {
    [CONFIGURATION_FEATURE_SETTINGS_MODES.Enabled]: {
        icon: CheckCircleIcon,
        iconColor: colors.blue700
    },
    [CONFIGURATION_FEATURE_SETTINGS_MODES.ReportingOnly]: {
        icon: RadioButtonCheckedIcon,
        iconColor: colors.orange900
    },
    [CONFIGURATION_FEATURE_SETTINGS_MODES.Disabled]: {
        icon: AutoSyncOff,
        iconColor: colors.textPlaceholder
    }
};

export const SYNC_MODES = Object.keys(
    SYNC_MODE_OPTIONS
) as CONFIGURATION_FEATURE_SETTINGS_MODES[];
